import React from 'react';
import { Layout, GeneralContact } from '../components';

const ContactUs = () => {
  return (
    <div className="ContactUs">
      <Layout>
        <GeneralContact />
      </Layout>
    </div>
  );
};

export default ContactUs;
